var modules_94312347 = {"container":"SberPromo_module_container__f769a2ec","important":"SberPromo_module_important__f769a2ec","fixedColor":"SberPromo_module_fixedColor__f769a2ec","countDownString":"SberPromo_module_countDownString__f769a2ec"};
import "../../assets/esm/SberPromo/src/SberPromo~nLbz8Ova.css";

export { modules_94312347 as default };
//# sourceMappingURL=SberPromo.module.less.js.map
